export default __webpack_public_path__ + "static/17-517b3d97abcf1d9be7770c5bf45bc385.jpg";